module.exports = __webpack_public_path__ + "static/red_dragon-e35c7b6ced35dea8f05275e8131758c1.jpg";